import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const FieldAddRoute: Route = {
  path: 'field-add',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/field-add.component').then((m) => m.FieldAddComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
